import axios from 'axios';
import { GET_USER_CLIENTS } from '../../constants';

/**
 * Function to get user client
 */
export const getUserClientApi = (payload) => axios.get(GET_USER_CLIENTS, { params: payload });

